import React from 'react';

import { Image, IImageProps } from './Image';

export interface IRoundImageProps extends IImageProps {}

export function RoundImage({
  size = 20,
  style,
  ...props
}: IRoundImageProps) {
  const borderRadius = size / 2;

  return (
    <Image
      style={[{ width: size, height: size, borderRadius }, style]}
      size={size}
      {...props}
    />
  );
}
